// extracted by mini-css-extract-plugin
module.exports = {"ellipseBorder":"Ellipse_ellipseBorder__M0P7Y"};